import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fin-mmb-split-panel',
  templateUrl: './mmb-split-panel.component.html',
  styleUrl: './mmb-split-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MmbSplitPanelComponent {}
